import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f94a33f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-record-list" }
const _hoisted_2 = {
  key: 1,
  style: {"margin":"10px 0","height":"1px","width":"100%","background":"#e5e5e5"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {} }
const _hoisted_5 = {
  class: "xrk-alert xrk-alert--warning is-light",
  role: "alert"
}
const _hoisted_6 = { class: "xrk-icon xrk-alert__icon is-big" }
const _hoisted_7 = { class: "xrk-alert__content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "xrk-alert__title with-description",
  style: {"color":"#ff5252"}
}, " 审核要求 ", -1))
const _hoisted_9 = {
  class: "xrk-alert__description",
  style: {"color":"#ff5252"}
}
const _hoisted_10 = { style: {"margin":"10px","display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"margin-right":"5px"},
  class: "title"
}, "结果全选", -1))
const _hoisted_13 = { class: "title" }
const _hoisted_14 = {
  key: 1,
  style: {"display":"flex"}
}
const _hoisted_15 = { style: {"margin-right":"5px"} }
const _hoisted_16 = {
  key: 0,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"22px","font-size":"14px","margin-right":"5px","color":"#121619","text-align":"left","font-style":"normal","text-transform":"none"} }, " 是否允许超量审核 ", -1))
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","align-items":"center","margin-bottom":"6px"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(220 56 34)"} }, "提示：*标记为"),
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"20px","height":"20px","margin":"0 3px"},
    src: "https://oss.myxrk.com/myxrk-v2/front-end/assets/oss/icon/2509011532.png"
  }),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(220 56 34)"} }, " 任务存在提交的图片存在重复，请注意查看 ")
], -1))
const _hoisted_20 = [
  _hoisted_19
]

import { ref, computed, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';

import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton,
  XrkTableRef,
  BaseSwitch,
  BaseCheckbox,
  createDialog,
  useCreateModal,
  XrkMessage,
  BaseDatePicker,
  useSelectColumn,
  BaseIcon
} from 'xrk-components';
import { WarningFilled, Close } from '@element-plus/icons-vue';

import SetDisplayInfo from './set-display-info.vue';
import AddTaskNumList from './add-task-num-list.vue';
import BaseAuditStatusSelect from '@/components/biz/biz-status-select/index';
import ImportSettlementAmount from './import-settlement-amount.vue';

import { searchByProjectType } from '../fields/searchs';
import { columnsByProjectType } from '../fields/columns';

import {
  taskRecordList,
  setExcessAudit,
  addTaskNumAjax,
  downloadTask,
  taskRecordStats,
  getProjectInfo,
  getOverdue,
  batchOverdue,
  getTaskRecordIds,
  submitTask,
  selectSimilartList,
  exportTaskRecordList
} from '../data-source/apis';

import { ProjectType } from '../types';
import { useTaskAudit, useOpenTaskDetail } from '../hooks/useTaskAudit';
import { MAX_SELECT_LENGTH } from '../constants/index';
import OperationRecord from '../components/operation-record.vue';
import RepeatPickure from './repeat-pickure.vue';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import { getUnqualifiedRowConfig } from '@/utils/unqualified';

import appStore from '@/store';

type Item = { label: string; value: number; num: number };

export default /*#__PURE__*/_defineComponent({
  __name: 'task-record-list',
  setup(__props) {

const router = useRouter();
const route = useRoute();

// 工业-1 服务商-2 供应商-3
const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);

/**
 * 是否是服务商
 */
const isAsp = computed(() => defaultUserFnCode.value === 2);

const auditStatusSelectDefaultValue = ref(route.query.activityName ? null : 0);
const auditStatusSelectKey = ref(0);

const xrkTableRef = ref<XrkTableRef>();

const excessiAudit = ref(0);
const tableDataRow = ref([]); //当前搜索条件下可勾选的id
const isSelectionAll = ref(false);

const refreshTableRender = ref(0);

const statusMap = ref<Item[]>(null); // 审核状态+条数

// 勾选列表数据
const selectionRows = computed(() => {
  return xrkTableRef.value?.getSelectionRows() || [];
});
const isIndeterminate = computed(() => {
  if (selectionRows.value.length === 0) {
    return false;
  }
  return selectionRows.value.length !== tableDataRow.value.length;
});
const onSelectionAllChange = (val: boolean) => {
  if (val) {
    tableDataRow.value.forEach(item => {
      xrkTableRef.value.addSelectionRow(item, {
        [projectType.value === 6 ? 'userId' : 'id']: item
      });
    });
  } else {
    xrkTableRef.value.clearSelectionRows();
  }
  isSelectionAll.value = val;
};

// 勾选列表数据变化时，更新全选状态
watch(
  () => selectionRows.value,
  val => {
    if (val.length === 0) {
      isSelectionAll.value = false;
      return;
    }
    isSelectionAll.value = val.length === tableDataRow.value.length;
  }
);
const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);
// store.setBaseData({
//   ...store.baseData,
//   projectInfo: {
//     ...projectInfo.value,
//     id: 7,
//     sceneType: 19
//   }
// });
const projectType = computed<ProjectType>(() => {
  return projectInfo.value.sceneType;
});

const projectId = computed<number>(() => {
  return projectInfo.value.id;
});

//协定服务上传来源1ASP上传2C端上传3双方共同上传
const agreementServiceUploadType = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadType;
});

//协定服务上传方式1以活动方式上传2以人为维度上传
const agreementServiceUploadMode = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadMode;
});

const isEntry = [
  +agreementServiceUploadMode.value,
  +agreementServiceUploadType.value
].join(',');
// '1,3': '活动形式-双方共同上传',
// '1,1': '活动形式-服务商上传',
// '2,2': '人为维度-终端上传',
// '2,1': '人为维度-服务商上传',
const canAudit = computed(() => {
  return (
    [21, 17, 5, 20].includes(projectType.value) ||
    ['1,3', '2,2'].includes(isEntry)
  );
});

const onRefreshTabel = () => {
  xrkTableRef.value?.initCurrentList();
};
const onChangeExcessiAudit = () => {
  setExcessAudit({
    projectId: projectId.value,
    sceneType: projectType.value,
    excessAudit: excessiAudit.value
  }).then(() => {
    onRefreshTabel();
  });
};
/**
 * 批量审核
 * @param status 审核状态
 */
const onBatchAudit = status => {
  useTaskAudit({
    auditStatus: status,
    projectId: projectId.value,
    isBatch: true,
    queryParams: {
      sceneType: projectType.value,
      taskRecordId: selectionRows.value.map(item => item.id)
    },
    auditOver() {
      xrkTableRef.value.clearSelectionRows();
      onRefreshTabel();
    }
  });
};

const ajaxProjectInfo = ref<{ projectRequire: string }>({
  projectRequire: ''
});

const showProjectRequire = ref(false);
const showProjectRequireBtn = computed(() => {
  return !!ajaxProjectInfo.value.projectRequire;
});
const isSetTime = ref(0);
const onGetAjaxProjectInfo = async () => {
  const { data: projectInfo } = await getProjectInfo({
    projectId: projectId.value
  });
  ajaxProjectInfo.value = projectInfo;
  isSetTime.value = projectInfo.setTime;
  showProjectRequire.value = !!ajaxProjectInfo.value.projectRequire;
};
onGetAjaxProjectInfo();

const onGetAuditRequire = e => {
  showProjectRequire.value = e;
};

const onAddTaskNum = () => {
  const addTaskNumListRef = ref();
  createDialog({
    title: '添加任务量',
    width: 800,
    confirmBtnConfig: {
      content: '确认添加'
    },
    contentRender: () => {
      return (
        <div style="padding: 20px">
          <AddTaskNumList ref={addTaskNumListRef} projectId={projectId.value} />
        </div>
      );
    },
    async beforeConfirm() {
      const data = addTaskNumListRef.value.getSelectData();
      await addTaskNumAjax({ taskNumVOList: data });
      onRefreshTabel();
    }
  });
};

/**
 * 导入结算金额
 */
const onImportSettlementAmount = () => {
  useCreateModal(ImportSettlementAmount, {
    onDownLoadTaskList() {
      const searchVal = xrkTableRef.value.getSearchValue();
      const [editStatusAtStart, editStatusAtEnd] = searchVal.editStatusAt || [
        '',
        ''
      ];
      const [visitDtStart, visitDtEnd] = searchVal.visitDt || ['', ''];
      const generalAuditStatus =
        searchVal.generalAuditStatus === (isAsp.value && undefined)
          ? [0]
          : searchVal.generalAuditStatus;

      const reqData = {
        ...searchVal,
        sceneType: projectType.value,
        projectId: projectId.value,
        editStatusAtStart,
        editStatusAtEnd,
        visitDtStart,
        visitDtEnd,
        generalAuditStatus
      };
      downloadTask(reqData);
    },
    onRefreshTabel() {
      onRefreshTabel();
    }
  });
};

/**
 * 任务过期
 */
const taskExpire = async () => {
  if (!selectionRows.value.length) {
    XrkMessage.error('请选择需要过期的任务');
    return;
  }
  const countdownRef = ref(3);
  const timer = setInterval(() => {
    countdownRef.value--;
    if (countdownRef.value <= 0) {
      clearInterval(timer);
    }
  }, 1000);

  const overdueDate = ref([]); //过期时间 数字专区用

  const overdueIds = ref([]); //后端筛选出的可以过期的id

  const getOverdueIds = async () => {
    const params = {
      projectId: projectId.value,
      sceneType: projectType.value,
      taskRecordId: selectionRows.value.map(item => item.id),
      userId: selectionRows.value.map(item => item.userId),
      createAtStart: overdueDate.value.length ? overdueDate.value[0] : '',
      createAtEnd: overdueDate.value.length ? overdueDate.value[1] : ''
    };
    if (projectType.value === 6) {
      delete params.taskRecordId;
    } else {
      delete params.userId;
    }
    const { data } = await getOverdue(params);
    if (!data || !data.length) {
      XrkMessage.error('没有可以过期的任务');
      return;
    }
    overdueIds.value = data;
  };

  const footerRender = done => {
    return (
      <div>
        <BaseButton
          type="default"
          onClick={() => {
            clearInterval(timer);
            done();
          }}
        >
          取消
        </BaseButton>
        <BaseButton
          type="primary"
          disabled={countdownRef.value > 0}
          onClick={async () => {
            if (!overdueDate.value && projectType.value === 6) {
              XrkMessage.error('请选择过期时间');
              return;
            }
            const params = {
              projectId: projectId.value,
              sceneType: projectType.value,
              taskRecordId: overdueIds.value,
              createAtStart: overdueDate.value.length
                ? overdueDate.value[0]
                : '',
              createAtEnd: overdueDate.value.length ? overdueDate.value[1] : ''
            };
            await batchOverdue(params);
            XrkMessage.success('操作成功');
            clearInterval(timer);
            done();
            onRefreshTabel();
            xrkTableRef.value.clearSelectionRows();
          }}
        >
          {countdownRef.value > 0 ? countdownRef.value + 's' : '确定'}
        </BaseButton>
      </div>
    );
  };

  if (projectType.value === 6) {
    createDialog({
      width: 350,
      title: '提示',
      showClose: true,
      closeOnPressEscape: true,
      contentRender() {
        return (
          <>
            <div style="padding: 20px">
              <div>选择过期时间</div>
              <BaseDatePicker
                type="daterange"
                style="width: 100%"
                v-model={overdueDate.value}
                onChange={async () => {
                  await getOverdueIds();
                }}
              ></BaseDatePicker>
              {overdueIds.value.length > 0 && (
                <span style="margin-top: 10px">{`您确定将 ${overdueIds.value.length} 条任务标记为过期吗，此操作不可撤回`}</span>
              )}
            </div>
          </>
        );
      },
      footerRender,
      onClose() {
        clearInterval(timer);
      }
    });
    return;
  }
  await getOverdueIds();
  overdueIds.value.length > 0 &&
    createDialog({
      width: 350,
      title: '提示',
      showClose: true,
      closeOnPressEscape: true,
      content: `您确定将 ${overdueIds.value.length} 条任务标记为过期吗，此操作不可撤回`,
      footerRender,
      onClose() {
        clearInterval(timer);
      }
    });
};
const onChangeAuditStatus = (val: string[]) => {
  const _val = val.filter(item => item !== null);
  xrkTableRef.value?.setSearchValue(
    'generalAuditStatus',
    _val.length ? _val : null
  );
  onRefreshTabel();
  xrkTableRef?.value?.clearSelectionRows();
};

//不展示快捷审核
const dontShowAuickAudit = computed(() => {
  return [6, 19, 21].includes(projectType.value) || !isAsp.value;
});

//是否是个体
const isGeti = computed(() => {
  return projectInfo.value.ctype === 3;
});

// 展示审核不通过企业类型
const showReject = computed(() => {
  return xrkTableRef.value?.getSearchValue().generalAuditStatus?.includes(3);
});

// 搜索项
const searchConfig = computed<XrkTableProps['searchConfig']>(() => {
  return {
    searchBtn: {
      show: true,
      text: '搜索'
    },
    resetBtn: {
      show: true,
      text: '重置',
      beforeReset() {
        auditStatusSelectKey.value++;
        auditStatusSelectDefaultValue.value = 0;
      }
    },
    searchColumns: [
      ...searchByProjectType(
        projectType.value,
        isEntry,
        isGeti.value,
        isSetTime.value
      ),
      showReject.value &&
        useSelectColumn({
          prop: 'rejectAuditPlatform',
          label: '审核不通过企业类型',
          config: {
            placeholder: '请选择',
            options: {
              0: { label: '平台方', value: 0 },
              1: { label: '服务商', value: 1 }
            },
            clearable: true
          }
        })
    ].filter(Boolean),
    otherComponents: [
      {
        render() {
          return (
            <>
              {projectType.value !== 6 && (
                <BaseButton
                  v-resource={[['任务记录_导出']]}
                  type="primary2"
                  click={async () => {
                    if (pageTableData.value.length === 0) {
                      XrkMessage.error('当前列表暂无数据，暂无法导出哦～');
                      return;
                    }
                    await exportTaskRecordList(searchParams.value);
                    XrkMessage.success('下载成功，请前往下载中心查看');
                  }}
                >
                  导出
                </BaseButton>
              )}

              {!dontShowAuickAudit.value && (
                <BaseButton
                  v-resource={[['任务记录_审核任务']]}
                  type="primary2"
                  onClick={() => {
                    useCreateModal(SetDisplayInfo, {
                      projectId: projectId.value,
                      projectType: projectType.value,
                      onConfirm() {
                        router.push({
                          path: '/main/asp/task-mgmt-list/quick-list',
                          query: {
                            projectId: projectId.value,
                            projectType: projectType.value
                          }
                        });
                      }
                    });
                  }}
                >
                  快捷审核
                </BaseButton>
              )}
            </>
          );
        }
      }
    ]
  };
});

/**
 * 查看任务详情
 * @param id
 */
const onTaskDetail = async (id: number, dataState: number) => {
  useOpenTaskDetail({
    id,
    dataState,
    projectType: projectType.value,
    projectId: projectId.value,
    canAudit: canAudit.value,
    xrkTableRef
  });
};

const repeatPickurePerview = (row, similarTaskIdList) => {
  createDialog({
    width: 1500,
    title: '图片重复关联项目',
    showClose: true,
    contentRender: () => {
      return (
        <div style="padding: 20px;">
          <RepeatPickure
            projectId={projectId.value}
            taskId={row.id}
            similarTaskIdList={similarTaskIdList}
          ></RepeatPickure>
        </div>
      );
    },
    beforeConfirm: async done => {
      done();
    }
  });
};
// 列表
const tableConfig = computed<XrkTableProps['tableConfig']>(() => {
  return {
    tableColumns: [
      isAsp.value &&
        useTableColumn({
          type: '_selection',
          prop: projectType.value === 6 ? 'userId' : 'id',
          align: 'center',
          fixed: 'left',
          width: 60,
          selectionDisabled(row) {
            if (projectType.value === 6) {
              //数字专区不审核此勾选为任务过期
              return false;
            }
            return (
              row.superviseStatus !== 1 ||
              row.isOverdue === 1 || //已过期
              row.dataState === 2 || //已结算
              row.settlementCount > 0 || //已结算任务量
              row.overdueCount > 0 || //过期任务量
              row.platformAuditStatus === 1 //平台审核中
            );
          }
        }),
      useTableColumn({
        type: 'index',
        label: '序号',
        width: '65px',
        fixed: 'left',
        render: ({ row, index }) => {
          const hasRepeatPicIds = Object.keys(repitImgList.value);
          const isHasRepeatPic = hasRepeatPicIds.includes(String(row.id));
          return (
            <div>
              {isHasRepeatPic && (
                <img
                  src="https://oss.myxrk.com/myxrk-v2/front-end/assets/oss/icon/2509011532.png"
                  style="cursor:pointer;width:20px;"
                  onClick={() => {
                    repeatPickurePerview(row, repitImgList.value[row.id]);
                  }}
                  type="text"
                />
              )}
              <span>{index + 1}</span>
            </div>
          );
        }
      }),
      ...columnsByProjectType(
        projectType.value,
        isEntry,
        xrkTableRef,
        defaultUserFnCode.value,
        isGeti.value,
        isSetTime.value
      ),
      useTableColumn({
        align: 'center',
        fixed: 'right',
        label: '操作',
        width: 230,
        render({ row }) {
          return (
            <>
              <div>
                <BaseButton
                  style="margin-right: 12px"
                  onClick={async () => {
                    onTaskDetail(row.id, row.dataState);
                  }}
                  type="text"
                >
                  查看
                </BaseButton>
                {isAsp.value && (
                  <div style="display:inline-block">
                    {canAudit.value && (
                      <>
                        <BaseButton
                          v-resource={[['任务记录_审核任务']]}
                          disabled={
                            row.buttonOnOff === 0 || row.buttonOnOff === 2
                          }
                          onClick={() => {
                            useTaskAudit({
                              auditStatus: 2,
                              projectId: projectId.value,
                              queryParams: {
                                sceneType: projectType.value,
                                taskRecordId: [row.id]
                              },
                              auditOver() {
                                xrkTableRef.value.clearSelectionRows();
                                onRefreshTabel();
                              }
                            });
                          }}
                          type="text"
                        >
                          通过
                        </BaseButton>
                        <BaseButton
                          v-resource={[['任务记录_审核任务']]}
                          disabled={row.buttonOnOff === 0}
                          onClick={() => {
                            useTaskAudit({
                              auditStatus: 3,
                              projectId: projectId.value,
                              queryParams: {
                                sceneType: projectType.value,
                                taskRecordId: [row.id]
                              },
                              auditOver() {
                                xrkTableRef.value.clearSelectionRows();
                                onRefreshTabel();
                              }
                            });
                          }}
                          type="text"
                        >
                          不通过
                        </BaseButton>
                      </>
                    )}
                    {projectType.value === 19 &&
                      !['2,2', '1,3'].includes(isEntry) && (
                        <BaseButton
                          v-resource={[['任务记录_审核任务']]}
                          disabled={
                            row.fileStatus === 0 ||
                            !row.price ||
                            row.platformAuditStatus === 1 ||
                            row.platformAuditStatus === 2 ||
                            row.isOverdue === 1
                          }
                          onClick={async () => {
                            await submitTask({
                              taskRecordId: row.id,
                              projectId: projectId.value
                            });
                            onRefreshTabel();
                          }}
                          type="text"
                        >
                          提交
                        </BaseButton>
                      )}
                    <BaseButton
                      v-resource={[['任务记录_审核任务']]}
                      onClick={async () => {
                        createDialog({
                          width: 850,
                          title: '操作记录',
                          showClose: true,
                          closeOnPressEscape: true,
                          contentRender: () => {
                            return (
                              <div style="padding: 20px;">
                                <OperationRecord
                                  taskRecordId={row.id}
                                ></OperationRecord>
                              </div>
                            );
                          },
                          beforeConfirm: async done => {
                            done();
                          }
                        });
                      }}
                      type="text"
                    >
                      操作记录
                    </BaseButton>
                  </div>
                )}
              </div>
            </>
          );
        }
      })
    ].filter(Boolean),
    baseConfig: {
      resizable: true,
      rowKey: projectType.value === 6 ? 'userId' : 'id',
      rowClassName({ row, rowIndex }) {
        const isUnqualified = () => {
          if (row?.isOverdue === 1 || row?.dataState === 2) {
            return true;
          }
          return row?.superviseStatus === 1;
        };
        return getUnqualifiedRowConfig({
          row: row,
          rowIndex: rowIndex,
          isNotUnqualified: isUnqualified()
        });
      },
      onSortChange: data => {
        let prop = String(data.prop); // 显式转换为字符串
        const order = String(data.order) === 'null' ? '' : String(data.order); // 显式转换为字符串

        if (prop === 'editStatusAt') {
          prop = 'finishDt';
        }

        xrkTableRef.value.setSearchValue(`${prop}Order`, order);
        xrkTableRef.value.initCurrentList();
      },
      onSelect(selection: any, row: any) {
        if (selection.length > MAX_SELECT_LENGTH) {
          XrkMessage.warning('最多只能选择' + MAX_SELECT_LENGTH + '条数据');
          xrkTableRef.value.removeSelectionRow(row.id);
        }
      },
      onSelectAll(selection) {
        if (selection.length > MAX_SELECT_LENGTH) {
          // 获取selection超过MAX_SELECT_LENGTH个的时候，清除多余的selection
          XrkMessage.warning('最多只能选择' + MAX_SELECT_LENGTH + '条数据');
          selection.slice(MAX_SELECT_LENGTH).forEach((item: any) => {
            xrkTableRef.value.removeSelectionRow(item.id);
          });
        }
      }
    }
  };
});

const getRecordStatsAjax = async params => {
  const { data } = await taskRecordStats(params);
  statusMap.value = [
    {
      label: '全部',
      value: null,
      num: Object.values(data).reduce((acc, cur) => acc + cur, 0)
    },
    {
      label:
        projectType.value === 19 && !['2,2', '1,3'].includes(isEntry)
          ? '待提交'
          : '待审核',
      value: 0,
      num: data.supplierPending
    },
    {
      label: '待平台审核',
      value: 1,
      num: data.platformPending
    },
    {
      label: '审核通过',
      value: 2,
      num: data.approved
    },
    {
      label: '审核未通过',
      value: 3,
      num: data.rejected
    }
  ];
  const { data: projectInfo } = await getProjectInfo({
    projectId: projectId.value
  });
  excessiAudit.value = projectInfo.isExcessAudit;
};
const pageTableData = ref([]); // 当前列表数据

// 重复图片列表
const repitImgList = ref({});

const hasRepeatPic = computed(() => {
  // 当前是否有重复图片
  return Object.keys(repitImgList.value).length > 0;
});
const getRepitImgList = async () => {
  const { data } = await selectSimilartList({
    projectId: projectId.value,
    taskIdList: pageTableData.value.map(i => i.id)
  });
  repitImgList.value = data || {};
  refreshTableRender.value++;
};

// 获取当前搜索条件下可勾选的id集合
const getRecordIds = async params => {
  const { data } = await getTaskRecordIds(params, 'task');
  tableDataRow.value = data || [];
};

const searchParams = ref({});

const getListAjax = async params => {
  const [editStatusAtStart, editStatusAtEnd] = params.editStatusAt || ['', ''];
  const [visitDtStart, visitDtEnd] = params.visitDt || ['', ''];

  // 上方状态选择框的搜索值
  let generalAuditStatus =
    params.generalAuditStatus === (isAsp.value && undefined)
      ? [auditStatusSelectDefaultValue.value]
      : params.generalAuditStatus;

  if (projectType.value === 6) generalAuditStatus = null;
  generalAuditStatus =
    generalAuditStatus?.length === 1 && generalAuditStatus[0] === null
      ? null
      : generalAuditStatus;

  const reqData = {
    ...params,
    rejectAuditPlatform: showReject.value ? params.rejectAuditPlatform : null,
    sceneType: projectType.value,
    projectId: projectId.value,
    editStatusAtStart,
    editStatusAtEnd,
    visitDtStart,
    visitDtEnd,
    generalAuditStatus
  };
  const data = await taskRecordList(reqData);
  searchParams.value = reqData;
  pageTableData.value = data.data.list;
  await getRecordStatsAjax({
    sceneType: projectType.value,
    projectId: projectId.value
  });
  isAsp.value && (await getRecordIds(reqData));
  isAsp.value && getRepitImgList();

  searchParams.value = reqData;
  return data;
};

return (_ctx: any,_cache: any) => {
  const _directive_resource = _resolveDirective("resource")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isAsp.value && projectType.value !== 6)
      ? (_openBlock(), _createBlock(_unref(BaseAuditStatusSelect), {
          key: auditStatusSelectKey.value,
          onChangeStatus: onChangeAuditStatus,
          statusMap: statusMap.value,
          defaultValue: auditStatusSelectDefaultValue.value
        }, null, 8, ["statusMap", "defaultValue"]))
      : _createCommentVNode("", true),
    (isAsp.value && projectType.value !== 6)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, {
      tableBefore: _withCtx(() => [
        (isAsp.value)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("i", _hoisted_6, [
                    _createVNode(_unref(BaseIcon), {
                      class: "contract",
                      color: "#ff5252"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(WarningFilled))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("p", _hoisted_9, _toDisplayString(ajaxProjectInfo.value.projectRequire), 1),
                    _createElementVNode("i", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (onGetAuditRequire(false))),
                      class: "xrk-icon xrk-alert__close-btn"
                    }, [
                      _createVNode(_unref(BaseIcon), {
                        style: {"color":"#898989"},
                        size: "16"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Close))
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ], 512)), [
              [_vShow, ajaxProjectInfo.value.projectRequire && showProjectRequire.value]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          (isAsp.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_unref(BaseCheckbox), {
                  indeterminate: isIndeterminate.value,
                  modelValue: isSelectionAll.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isSelectionAll).value = $event)),
                  onChange: onSelectionAllChange
                }, null, 8, ["indeterminate", "modelValue"]),
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, " 已选" + _toDisplayString(selectionRows.value.length) + "条，批量操作 ", 1),
                (canAudit.value)
                  ? _withDirectives((_openBlock(), _createBlock(_unref(BaseButton), {
                      key: 0,
                      style: {"margin-left":"10px"},
                      type: "default",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (onBatchAudit(2)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 通过 ")
                      ]),
                      _: 1
                    })), [
                      [_directive_resource, ['任务记录_审核任务']]
                    ])
                  : _createCommentVNode("", true),
                (canAudit.value)
                  ? _withDirectives((_openBlock(), _createBlock(_unref(BaseButton), {
                      key: 1,
                      type: "default",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (onBatchAudit(3)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 不通过 ")
                      ]),
                      _: 1
                    })), [
                      [_directive_resource, ['任务记录_审核任务']]
                    ])
                  : _createCommentVNode("", true),
                _withDirectives((_openBlock(), _createBlock(_unref(BaseButton), {
                  type: "default",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (taskExpire()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 任务过期 ")
                  ]),
                  _: 1
                })), [
                  [_directive_resource, ['任务记录_任务过期']]
                ]),
                (showProjectRequireBtn.value)
                  ? (_openBlock(), _createBlock(_unref(BaseButton), {
                      key: 2,
                      type: "default",
                      onClick: onGetAuditRequire
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 查看审核要求 ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (isAsp.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (['2,1'].includes(_unref(isEntry)))
                    ? (_openBlock(), _createBlock(_unref(BaseButton), {
                        key: 0,
                        type: "default",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (onAddTaskNum()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 添加任务量 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (['2,1', '2,2'].includes(_unref(isEntry)))
                    ? (_openBlock(), _createBlock(_unref(BaseButton), {
                        key: 1,
                        type: "default",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (onImportSettlementAmount()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 导入结算金额 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                (canAudit.value && projectType.value !== 19)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_unref(BaseSwitch), {
                        "active-value": 1,
                        "inactive-value": 0,
                        "active-text": excessiAudit.value ? '允许' : '不允许',
                        modelValue: excessiAudit.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((excessiAudit).value = $event)),
                        onChange: onChangeExcessiAudit
                      }, null, 8, ["active-text", "modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (isAsp.value && hasRepeatPic.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})